(function ($) {
	$.fn.header = function () {
		let $el = this;

		const init = function () {
			load();

			$(window).bind('resize scroll', function () {
				load();
			});
		};

		const load = function () {
			const $hero = $('body').find('.section--type-hero');
			const $page = $('#page');

			// Shrinking of the header.
			if ($(window).width() >= 745 && $(window).scrollTop() > 96) {
				$el.addClass('header--shrinked');
			} else {
				$el.removeClass('header--shrinked');
			}

			// Floating of the header (basically the white background kekw).
			if ($hero.length > 0) {
				if (
					$(window).scrollTop() + $el.outerHeight() / 2 >
					$page.offset().top
				) {
					$el.addClass('header--inverted').addClass(
						'header--floating'
					);
					$hero.addClass('hero--hidden');
				} else {
					$el.removeClass('header--inverted').removeClass(
						'header--floating'
					);
					$hero.removeClass('hero--hidden');
				}
			} else {
				$el.addClass('header--inverted');
				$hero.addClass('hero--hidden');

				if ($(window).scrollTop() > 96) {
					$el.addClass('header--floating');
				} else {
					$el.removeClass('header--floating');
				}
			}

			// Fly in the menu parts.
			$el.addClass('loaded');
		};

		if (this.length > 0) {
			if (this.length > 1) {
				this.each(function () {
					$(this).header();
				});
			} else {
				$el = this;
				init();
			}
		}
	};

	$(document).ready(function () {
		$('.header').header();
	});
})(jQuery);
